// tslint:disable:no-console
export class Logger {
  constructor(private logsEnabled = true) {}
  log(message: {}) {
    this.logsEnabled && console.log(message)
  }
  info(message: {}) {
    this.logsEnabled && console.info(message)
  }
  warn(message: {}) {
    this.logsEnabled && console.warn(message)
  }
  error(error: Error, additionalMessage?: {}) {
    this.logsEnabled && console.error(error, additionalMessage)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/logger.service.ts